module.exports = __webpack_public_path__ + "static/img/local_life_pic.5a3fa4dc.png";